(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kg-size-guide"] && !Shopify.designMode) return;
  try {
    if (!window.__kgSizeGuide) {
    window.__kgSizeGuide = true;

    const activateGuide = (dialog, guide) => {
      dialog.querySelectorAll('[data-kg-guide-tab]').forEach((tab) => {
        const selected = tab.dataset.kgGuideTab === guide;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.setAttribute('tabindex', selected ? '0' : '-1');
      });

      dialog.querySelectorAll('[data-kg-guide-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.kgGuidePanel === guide);
      });
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-kg-size-guide-open]');
      const closeButton = event.target.closest('[data-kg-size-guide-close]');
      const tab = event.target.closest('[data-kg-guide-tab]');
      const unit = event.target.closest('[data-kg-guide-unit]');

      if (openButton) {
        const dialog = document.getElementById(openButton.dataset.kgSizeGuideOpen);
        if (!dialog) return;
        activateGuide(dialog, dialog.dataset.activeGuide || 'bottoms');
        dialog.showModal();
        document.documentElement.classList.add('lock');
      }

      if (closeButton) closeButton.closest('dialog')?.close();
      if (tab) activateGuide(tab.closest('dialog'), tab.dataset.kgGuideTab);

      if (unit) {
        const dialog = unit.closest('dialog');
        const useCm = unit.dataset.kgGuideUnit === 'cm';
        dialog.classList.toggle('is-cm', useCm);
        dialog.querySelectorAll('[data-kg-guide-unit]').forEach((button) => button.classList.toggle('is-active', button === unit));
      }

      if (event.target.matches('dialog[data-kg-size-guide]')) event.target.close();
    });

    document.addEventListener('close', (event) => {
      if (event.target.matches('dialog[data-kg-size-guide]')) document.documentElement.classList.remove('lock');
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
